import { render, staticRenderFns } from "./ExpireInfoTrayForAlert.vue?vue&type=template&id=f4fc3f3c&scoped=true&"
import script from "./ExpireInfoTrayForAlert.vue?vue&type=script&lang=js&"
export * from "./ExpireInfoTrayForAlert.vue?vue&type=script&lang=js&"
import style0 from "./ExpireInfoTrayForAlert.vue?vue&type=style&index=0&id=f4fc3f3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4fc3f3c",
  null
  
)

export default component.exports